<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="finding-a-wife">
<h1>Finding a Wife</h1>
<p>Armando decided he was sick of chasing women. He needed a wife; a strong woman with striking looks, not beautiful and full of herself. Armando’s mother was a beautiful woman in her own way. She was in charge when his father was away from the castle. Now, there was only him and his sister, Helewise.</p>
<p>His parents and two brothers all died within days from the plague. He and his baby sister, Heloise were the two survivors. Armando was invited to dine with the Duke and Duchess of Landburg. And all of Transylvania must know he was looking for a wife.</p>
<p>So far, no one appealed to him. The Landburg’s castle was only one hour away on horseback. They were neighbors and friends of his parents.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?708578ae